import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import { EmojiIcon } from '../EmojiIcon';
import progressBarSrc from '../../assets/images/slide/graph-progress-bar.png';
import styles from './PlanGraphSlide.css';

const cx = classnames.bind(styles);

const DEFAULT_TOPICS = ['house', 'backpack', 'bottle', 'bride', 'new-mother', 'worker', 'tree'];

const MILESTONES = [
    {
        label: 'Today',
        percentText: '0% complete',
        percentVariant: 'red',
        completedCount: 0
    },
    {
        label: '3 Months',
        percentText: '30% complete',
        percentVariant: 'default',
        completedCount: 2
    },
    {
        label: '6 Months',
        percentText: '50% complete',
        percentVariant: 'default',
        completedCount: 4
    },
    {
        label: '1 Year',
        percentText: '100% complete',
        percentVariant: 'green',
        completedCount: 7
    }
];

function PlanGraphSlide({
    titlePrefix = 'Her story won’t write itself',
    titleAccent = 'before time runs out.',
    topics = DEFAULT_TOPICS,
    spriteVersion = 'v46'
}) {
    return (
        <div className={styles.form}>
            <h2 className={styles.heading}>
                {titlePrefix} <span className={styles.highlight}>{titleAccent}</span>
            </h2>
            <div className={styles.timeline}>
                <img src={progressBarSrc} alt='' className={styles.timelineTrack} />
                <div className={styles.cards}>
                    {MILESTONES.map(milestone => (
                        <div className={styles.card} key={milestone.label}>
                            <div className={styles.cardHeader}>
                                <p className={styles.cardLabel}>{milestone.label.toUpperCase()}</p>
                                <p className={cx('cardPercent', milestone.percentVariant)}>{milestone.percentText}</p>
                            </div>
                            <div className={styles.topicRow}>
                                {topics.map((topic, topicIndex) => (
                                    <div
                                        key={topic}
                                        className={cx('topicChip', { topicChipDone: topicIndex < milestone.completedCount })}
                                    >
                                        {topicIndex < milestone.completedCount
                                            ? <Icon name='checkItemFilled' className={styles.checkIcon} />
                                            : <EmojiIcon name={topic} version={spriteVersion} />
                                        }
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

PlanGraphSlide.propTypes = {
    titlePrefix: PropTypes.node,
    titleAccent: PropTypes.node,
    topics: PropTypes.arrayOf(PropTypes.string),
    spriteVersion: PropTypes.string
};

export {
    PlanGraphSlide
};
